import { useProductCard } from 'product-card/hooks/useProductCard'
import { useProductCardConsumerLayoutContext } from 'product-card/hooks/useProductCardConsumerLayoutContext'

export const useShowAsFeatured = () => {
	const { shouldRenderFeatured } = useProductCardConsumerLayoutContext()
	const { featured } = useProductCard()

	return shouldRenderFeatured && featured
}
